import { useSearchPerson, SearchPersonProps } from '@ltvco/refresh-lib/hooks';
import { SerializedPropertyReport } from '@ltvco/refresh-lib/v1';
import { ResidentResults, PersonSearchLoading } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useSearchParams } from 'react-router-dom';

export function SearchResidentResults() {
  const [searchParams] = useSearchParams();
  const address = searchParams.get('address') || '';
  const isInPartialAddressesVariation = useFeatureIsOn('OAR-1579');

  const SearchPersonQuery: SearchPersonProps = {
    searchPersonBy: 'address',
    options: {
      personSearchParams: {
        address,
        showPartialAddresses: isInPartialAddressesVariation,
      },
    },
  };

  let { data: searchPersonResult, isFetched } =
    useSearchPerson(SearchPersonQuery);
  searchPersonResult = searchPersonResult as SerializedPropertyReport;

  return (
    <>
      {!isFetched ? (
        <PersonSearchLoading />
      ) : (
        <ResidentResults
          searchAddress={address}
          residents={searchPersonResult?.properties?.[0]?.residents || []}
        />
      )}
    </>
  );
}
